/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DebtType } from './DebtType';
import {
    DebtTypeFromJSON,
    DebtTypeFromJSONTyped,
    DebtTypeToJSON,
    DebtTypeToJSONTyped,
} from './DebtType';

/**
 * 
 * @export
 * @interface DebtResponse
 */
export interface DebtResponse {
    /**
     * 
     * @type {string}
     * @memberof DebtResponse
     */
    id: string;
    /**
     * 
     * @type {DebtType}
     * @memberof DebtResponse
     */
    type: DebtType;
    /**
     * 
     * @type {string}
     * @memberof DebtResponse
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof DebtResponse
     */
    clientId: string;
}



/**
 * Check if a given object implements the DebtResponse interface.
 */
export function instanceOfDebtResponse(value: object): value is DebtResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function DebtResponseFromJSON(json: any): DebtResponse {
    return DebtResponseFromJSONTyped(json, false);
}

export function DebtResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebtResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': DebtTypeFromJSON(json['type']),
        'value': json['value'],
        'clientId': json['clientId'],
    };
}

export function DebtResponseToJSON(json: any): DebtResponse {
    return DebtResponseToJSONTyped(json, false);
}

export function DebtResponseToJSONTyped(value?: DebtResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': DebtTypeToJSON(value['type']),
        'value': value['value'],
        'clientId': value['clientId'],
    };
}

